import { createTheme } from '@mui/material/styles'

const basePalette = {
  primary: {
    light: '#26D07C',
    main: 'rgba(0, 159, 77, 1)',
    dark: '#2C5234',
    contrastText: '#fff',
    actionMain: '#5F6368',
  },
  secondary: {
    light: '#a95d64',
    main: '#9edf51',
    dark: '#470314',
    contrastText: '#fff',
  },
  error: {
    main: '#F44336',
  },
  warning: {
    main: '#FF9800',
    light: 'hsla(36, 100%, 50%, 1)',
  },
  info: {
    main: '#2196F3',
    dark: '#0B79D0',
    light: '#64B6F7',
  },
  colorPicker: {
    white: '#FFFFFF',
    grey: '#E3E2E0',
    brown: '#ECE0DB',
    orange: '#F5DFCC',
    yellow: '#FAEDCC',
    green: '#DEECDC',
    blue: '#D6E4EE',
    purple: '#E6DEED',
    pink: '#F1E1E9',
    red: '#FAE3DE',
  },
}

export const lightPalette = {
  mode: 'light',
  ...basePalette,
  primary: {
    ...basePalette.primary,
    lightBg: 'rgba(0, 159, 77, 0.08)',
  },
  error: {
    ...basePalette.error,
    background: 'rgba(244, 67, 54, 0.08)',
    hover: 'rgba(244, 67, 54, 0.15)',
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.95)',
    secondary: 'rgba(0, 0, 0, 0.74)',
    hint: 'rgba(0, 0, 0, 0.54)',
    disabled: 'rgba(0, 0, 0, 0.38)',
  },
  borderColor: {
    default: 'rgba(0, 0, 0, 0.23)',
  },
  background: {
    default: '#fff',
    settingsMenu: '#FAFAFA',
    landing: '#282c34',
    section: '#fafafa',
    item: 'rgba(0, 0, 0, 0.08)',
    transparent: 'rgba(0,0,0,0)',
    hover: '#ffffff',
    loading: 'rgba(255, 255, 255, 0.38)',
    color: 'rgba(235, 247, 241, 1)',
  },
  info: {
    ...basePalette.info,
    lightBg: 'rgba(236, 245, 254, 1)',
  },
}

export const darkPalette = {
  mode: 'dark',
  ...basePalette,
  primary: {
    ...basePalette.primary,
    lightBg: '#2C5234',
  },
  error: {
    ...basePalette.error,
    background: 'rgba(244, 67, 54, 0.15)',
    hover: 'rgba(244, 67, 54, 0.22)',
  },
  text: {
    primary: 'rgba(255, 255, 255, 0.95)',
    secondary: 'rgba(255, 255, 255, 0.74)',
    hint: 'rgba(255, 255, 255, 0.54)',
    disabled: 'rgba(255, 255, 255, 0.38)',
  },
  borderColor: {
    default: 'rgba(255, 255, 255, 0.23)',
  },
  background: {
    default: 'hsla(220, 15%, 18%, 1)',
    settingsMenu: 'hsla(220, 15%, 22%, 1)',
    landing: '#212121',
    section: 'hsla(220, 15%, 22%, 1)',
    item: 'rgba(255, 255, 255, 0.08)',
    transparent: 'rgba(0,0,0,0)',
    hover: 'hsla(220, 15%, 30%, 1)',
    loading: 'hsla(220, 15%, 18%, 0.38)',
    color: 'rgba(26, 36, 41, 1)',
  },
  info: {
    ...basePalette.info,
    lightBg: 'rgba(236, 245, 254, 0)',
  },
}

export const getTheme = mode => {
  return createTheme({
    palette: mode === 'dark' ? darkPalette : lightPalette,
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: ({ theme }) => ({
            // set MUI placeholder color to match current GS theme disabled text color
            '&::placeholder': {
              color: theme.palette.text.disabled,
              opacity: 1,
            },
          }),
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: ({ theme }) => ({
            color: theme.palette.text.primary,
          }),
        },
      },
    },
  })
}

export default getTheme('light')

export const theme = getTheme('light') // This sets the default theme to light
